/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Organism from './organism';
import OrganismDetail from './organism-detail';
import OrganismUpdate from './organism-update';
import OrganismDeleteDialog from './organism-delete-dialog';

const OrganismRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Organism />} />
    <Route path="new" element={<OrganismUpdate />} />
    <Route path=":id">
      <Route index element={<OrganismDetail />} />
      <Route path="edit" element={<OrganismUpdate />} />
      <Route path="delete" element={<OrganismDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default OrganismRoutes;
